import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "@/lib/auth";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { googleExchange } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      toast.error("Google sign-in was cancelled or the link is invalid.");
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const user = await googleExchange(sessionId);
        // Wipe the fragment so a refresh doesn't retry the exchange
        window.history.replaceState({}, "", "/admin");
        toast.success(`Welcome, ${(user.name || user.email).split(" ")[0]}.`);
        navigate("/admin", { replace: true });
      } catch (err) {
        toast.error(formatApiError(err));
        navigate("/admin/login", { replace: true });
      }
    })();
  }, [location.hash, googleExchange, navigate]);

  return (
    <div className="min-h-screen bg-[#0B0F19] flex items-center justify-center" data-testid="auth-callback-loading">
      <div className="flex flex-col items-center gap-4">
        <Loader2 size={28} className="text-nex-gold animate-spin" />
        <div className="mono-body text-[11px] uppercase tracking-[0.3em] text-nex-gold">
          Verifying your Google session…
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
